import React from "react";
import { Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import CardMembershipRoundedIcon from "@mui/icons-material/CardMembershipRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";

export default function NavbarAccountMenu({ anchorEl, user, navigation, membershipsEnabled = false, onClose, onAppointments, onMemberships, onLogout }) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: {
            mt: 1,
            minWidth: 245,
            borderRadius: 2.5,
            border: "1px solid",
            borderColor: "divider",
            boxShadow: "0 18px 48px rgba(20,25,35,.16)",
          },
        },
      }}
    >
      <Box sx={{ px: 2, py: 1.5 }}>
        <Typography fontWeight={900} noWrap>
          {user?.name || (navigation?.accountLabel ?? "Mi cuenta")}
        </Typography>
        <Typography variant="body2" color="text.secondary" noWrap>
          {user?.email || ""}
        </Typography>
      </Box>
      <Divider />
      <MenuItem onClick={onAppointments} sx={{ minHeight: 46, fontWeight: 850 }}>
        <EventAvailableRoundedIcon sx={{ mr: 1.2, fontSize: 20 }} />
        Mis turnos
      </MenuItem>
      {membershipsEnabled ? (
        <MenuItem onClick={onMemberships} sx={{ minHeight: 46, fontWeight: 850 }}>
          <CardMembershipRoundedIcon sx={{ mr: 1.2, fontSize: 20 }} />
          Mis mensualidades
        </MenuItem>
      ) : null}
      <Divider />
      <MenuItem onClick={onLogout} sx={{ minHeight: 46, color: "primary.main", fontWeight: 850 }}>
        <LogoutRoundedIcon sx={{ mr: 1.2, fontSize: 20 }} />
        {navigation?.logoutLabel ?? "Cerrar sesión"}
      </MenuItem>
    </Menu>
  );
}
